export default __webpack_public_path__ + "static/media/signup-mobile-4.01719a21.png";